module.exports = __webpack_public_path__ + "assets/webgl/Assets_2_base_color.jpg.astc.69f78463.ktx";